import { CheckCircle, Clock, XCircle, FileText } from "lucide-react";

export default function StatusBadge({ status }) {
  const map = {
    approved: ["b-app", "Approved", CheckCircle],
    pending:  ["b-pen", "Pending",  Clock],
    rejected: ["b-rej", "Rejected", XCircle],
    needs_review: ["b-pen", "Needs Review", Clock],
    recapture:    ["b-dft", "Recapture",    Clock],
    draft:    ["b-dft", "Draft",    FileText],
    active:   ["b-act", "Active",   CheckCircle],
    inactive: ["b-ina", "Inactive", XCircle],
  };
  const [cls, label, Icon] = map[status] || ["b-dft", status, Clock];
  return (
    <span className={`badge ${cls}`}>
      <Icon size={11} />
      {label}
    </span>
  );
}
